import axios from 'axios';

export default {
  state: {
    active: null,
    events: [],
    map: true,
    list: false,
    party: [],
    page: 0,
    type_events: 'all',
    joined: false,
    userCanAdd: false,
    hot_level: null,
  },
  mutations: {
    setParty(state, party) {
      state.party = party;
    },
    setHotLevel(state, level) {
      state.hot_level = level;
    },
    setTypeEvents(state, type) {
      state.type_events = type;
    },
    setEvents(state, events) {
      state.events = events;
    },
    nextPageEvents(state) {
      state.page++;
    },
    addEvent(state, event) {
      state.events.push(event);
    },
    deleteEvent(state, id) {
      let finded = state.events.find(event => event.id == id);
      finded ? state.events.splice(state.events.indexOf(finded), 1) : ''
    },
    setActiveEvent(state, active) {
      state.events.find(event => event.id === active.id) ? '' : state.events.push(active);
      state.active = active;
      state.party = active.users;
    },
    clearActiveEvent(state) {
      state.active = null;
      state.party = [];
    },
    setActiveEventSimple(state, active) {
      state.active = active;
    },
    changeMode(state, val) {
      state.map = val;
    },
    changeList(state, val) {
      state.list = val;
    },
    showJoined(state, val) {
      state.joined = val !== undefined ? val : !state.joined;
    },
    userCan(state, val) {
      state.userCanAdd = val;
    },
  },
  actions: {
    async createEvent({ commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/events/add`, params)
          .then((response) => {
            result = response.data;
            commit('addEvent', result);
            commit('setActiveEvent', result);
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    async deleteEvent({ commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/events/delete`, params)
          .then((response) => {
            result = response.data;
            commit('deleteEvent', params.event.id);
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    async updateEvent({ commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/events/edit`, params)
          .then((response) => {
            commit
            result = response.data;
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    async sendInvite({ commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/events/invite`, params)
          .then((responce) => {
            // commit('setEvents', responce.data)
            commit;
            result = responce.data;
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    async sendLike({ commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/events/like`, params)
          .then((responce) => {
            commit;
            result = responce.data;
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    async leaveFromEvent({ commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/events/leave`, params)
          .then((responce) => {
            commit;
            result = responce.data;
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    afterJoin({ commit }, canAdd) {
      commit('showJoined');
      canAdd != undefined ? commit('userCan', canAdd) : '';
    },
    showJoined({ commit }, val) {
      commit('showJoined', val);
    },
    setTypeEvents({ commit }, type) {
      commit('setTypeEvents', type);
    },
    async joinToEvent({ commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/events/join`, params)
          .then((response) => {
            commit;
            // console.log(response, 'join');
            result = response.data;
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    async fetchEvent({ commit }, params) {
      let result;
      try {
        commit('clearActiveEvent')
        await axios
          .post(`/api/events/event`, params)
          .then((response) => {
            commit('setActiveEvent', response.data)
            result = response.data;
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    async getEvents({ commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/events`, params)
          .then((response) => {
            // result = state.page > 0 ? state.events.concat(response.data) : response.data;
            result = response.data;
            commit('setEvents', result);
            // console.log(result, 'getEvents');
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    async fetchHotLevel({ commit }) {
      let result;
      await axios
        .get(`/api/statistic/hot`)
        .then((response) => {
          result = response.data;
          commit('setHotLevel', result.hot_level);
          // console.log(result, 'getHot');
        })
      return result
    },
    async sendEventComment({ commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/events/comment/create`, params)
          .then((response) => {
            commit
            result = response.data;
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    async sendEventCommentLike({ commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/events/comment/like/add`, params)
          .then((response) => {
            commit
            result = response.data;
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    async deleteEventCommentLike({ commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/events/comment/like/delete`, params)
          .then((response) => {
            commit
            result = response.data;
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    async nextPageEvents({ commit }) {
      commit('nextPageEvents');
    },
    async setEvents({ commit }, events) {
      commit('setEvents', events);
    },
    setActiveEvent({ commit }, active) {
      commit('setActiveEventSimple', active);
    },
    changeMode({ commit }, val) {
      commit('changeMode', val);
    },
    changeList({ commit }, val) {
      commit('changeList', val);
    },
    async jointToEvent({ commit }, user) {
      let result;
      try {
        await axios
          .post(`/api/join`, user)
          .then((responce) => {
            // commit('setJoinEvents', responce.data)
            result = responce.data;
            commit;
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
  },
  getters: {
    // getActiveEvents: s => s.activeEvents,
    getActiveEvent: (s) => s.active,
    getEvents: (s) => s.events,
    getEventsPage: (s) => s.page,
    getMode: (s) => s.map,
    getList: (s) => s.list,
    getPartyUsers: (s) => s.party,
    joined: (s) => s.joined,
    getTypeEvents: (s) => s.type_events,
    userCanAdd: (s) => s.userCanAdd,
    getHotLevel: (s) => s.hot_level,
  },
};
